import { Config } from '@comall-backend-builder/core/lib/parser';

import './product.less';

export let config: Config = {
    components: {
        PointProductInfoListView: {
            component: 'Card',
            entity: 'product',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'PointProductInfoFilter',
                    },
                    {
                        component: 'PointProductInfoBatchBtns',
                    },
                    {
                        component: 'PointProductInfoDataTable',
                    },
                ],
            },
        },

        PointProductInfoFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            params: {
                type: 'FK_POINTS',
            },
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sku',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'spu',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'brand',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        PointProductInfoBatchBtns: {
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量导入图片',
                        type: 'primary',
                        tooltip: '上传压缩文件格式为.zip格式，并且不超过100M',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.zip',
                    action: '/templates/UPDATE_IMAGE',
                    className: 'upload-button',
                },
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量导入修改展示名称',
                        type: 'primary',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.xls,.xlsx,.csv',
                    action: '/templates/UPDATE_SHOW_NAME',
                    className: 'upload-button',
                },
                {
                    component: 'ExportButton',
                    text: '下载模板',
                    type: 'default',
                    source: {
                        apiPath: '/templates/UPDATE_SHOW_NAME',
                    },
                    flex: '0 0 auto',
                },
            ],
        },

        PointProductInfoDataTable: {
            component: 'DataTable',
            params: {
                type: 'FK_POINTS',
            },
            switchRefresh: true,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'sku',
                },
                {
                    property: 'spu',
                },
                {
                    property: 'pzgPic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'middlePic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                },
                {
                    property: 'brand',
                    width: 120,
                },
                {
                    property: 'pointPrice',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 230,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '编辑',
                        path: '/product/point-info/{{row.id}}',
                    },
                ],
            },
        },

        PointProductInfoDetailView: {
            component: 'Card',
            content: {
                component: 'Tabs',
                items: [
                    {
                        title: '商品基础资料',
                        content: {
                            component: 'PointProductInfoDetailBaseForm',
                        },
                    },
                    {
                        title: '商品码表属性',
                        content: {
                            component: 'PointProductInfoDetailAttributeList',
                        },
                    },
                    {
                        title: '商品展示属性 - 电商',
                        content: {
                            component: 'PointProductInfoDetailInsideAttribute',
                        },
                    },
                    {
                        title: '商品展示属性 - 中台',
                        content: {
                            component: 'PointProductInfoDetailOutsideAttribute',
                        },
                    },
                ],
            },
        },

        PointProductInfoDetailBaseForm: {
            component: 'ModifyForm',
            entity: 'productBase',
            loaderType: 'get',
            direction: 'horizontal',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 8,
            footer: {
                style: {
                    textAlign: 'right',
                },
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                    },
                    {
                        text: '提交',
                        type: 'primary',
                        htmlType: 'submit',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            submitSuccessBehavior: {
                route: 'goBack',
            },
            fields: [
                {
                    property: 'sku',
                    modifiable: false,
                },
                {
                    property: 'spu',
                    modifiable: false,
                },
                {
                    property: 'name',
                    modifiable: false,
                },
                {
                    property: 'brand',
                    modifiable: false,
                },
                {
                    property: 'chargeType',
                    modifiable: false,
                },
                {
                    property: 'goldWeight',
                    modifiable: false,
                    displayConfig: {
                        className: 'suffix-weight',
                    },
                },
                {
                    property: 'salesTags',
                    modifiable: false,
                },
                {
                    property: 'blackRemark',
                    modifiable: false,
                },
                {
                    property: 'type',
                    modifiable: false,
                },
                {
                    property: 'weight',
                    modifiable: false,
                    displayConfig: {
                        className: 'suffix-weight',
                    },
                },
                {
                    property: 'showName',
                },
            ],
        },

        PointProductInfoDetailAttributeList: {
            component: 'DataTable',
            entity: 'productAttribute',
            loaderType: 'search',
            loadFirstPage: true,
            rowKey: 'id',
            columns: [
                {
                    property: 'key',
                },
                {
                    property: 'value',
                },
            ],
        },

        PointProductInfoDetailInsideAttribute: {
            component: 'Card',
            entity: 'productInsideAttribute',
            loaderType: 'get',
            content: {
                component: 'PointProductInfoShowAttributeInsideEditForm',
            },
        },

        PointProductInfoShowAttributeInsideEditForm: {
            component: 'ModifyForm',
            direction: 'vertical',
            footer: {
                style: {
                    textAlign: 'right',
                },
                items: [
                    {
                        text: '取消',
                        htmlType: 'button',
                        type: 'default',
                        route: 'goBack',
                    },
                    {
                        text: '提交',
                        type: 'primary',
                        htmlType: 'submit',
                        style: { marginLeft: 16 },
                    },
                ],
            },
            fields: [
                {
                    property: 'detailApp',
                    controlConfig: {
                        uploadConfig: {
                            apiPath: '/images',
                            fileName: 'fileName',
                        },
                    },
                },
                {
                    property: 'detailPc',
                    controlConfig: {
                        uploadConfig: {
                            apiPath: '/images',
                            fileName: 'fileName',
                        },
                    },
                },
                {
                    property: 'imageUrls',
                    controlConfig: {
                        maxCount: 5,
                        fileName: 'fileName',
                        uploadType: 'multi',
                        sortable: true,
                        multiple: true,
                        uploadUrl: `${ENV.API_ROOT}/images`,
                        mode: 'picture-card',
                        maxSize: 10240,
                        uploadLimitSizeErrorMessage:
                            '图片{{file.name}}超出限制，最大上传 {{maxSize}} kb 图片',
                        preview: {
                            visible: true,
                            size: 400,
                        },
                    },
                },
                {
                    property: 'videoUrl',
                    controlConfig: {
                        maxCount: 1,
                        fileName: 'file_name',
                        uploadUrl: `${ENV.API_ROOT}/video`,
                        mode: 'picture-card',
                        maxSize: 10 * 1024,
                    },
                },
            ],
            submitSuccessBehavior: {
                route: 'goBack',
            },
        },

        PointProductInfoDetailOutsideAttribute: {
            component: 'Card',
            entity: 'productOutsideAttribute',
            loaderType: 'get',
            content: {
                component: 'PointProductInfoShowAttributeOutsideForm',
            },
        },

        PointProductInfoShowAttributeOutsideForm: {
            component: 'ModifyForm',
            direction: 'vertical',
            className: 'product-info-show-attribute-outside-form',
            fields: [
                {
                    property: 'detailApp',
                    modifiable: false,
                },
                {
                    property: 'detailPc',
                    modifiable: false,
                },
                {
                    property: 'imageUrls',
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 104,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                        },
                    },
                },
                {
                    property: 'videoUrl',
                    modifiable: false,
                },
            ],
        },

        PointProductGoodsListView: {
            component: 'Card',
            entity: 'product',
            content: {
                component: 'FlexLayout',
                direction: 'vertical',
                align: 'justify',
                items: [
                    {
                        component: 'PointProductGoodsFilter',
                    },
                    {
                        component: 'PointProductGoodsBatchBtns',
                    },
                    {
                        component: 'PointProductGoodsDataTable',
                    },
                ],
            },
        },

        PointProductGoodsFilter: {
            component: 'FilterFormPlus',
            direction: 'horizontal',
            params: {
                type: 'FK_POINTS',
            },
            labelCol: 8,
            style: {
                marginBottom: 16,
            },
            fields: [
                {
                    property: 'name',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'sku',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'spu',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'saleStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'pullOffSaleStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'saleNumStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'putOnSaleStatus',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                {
                    property: 'matnr',
                    controlConfig: {
                        style: { width: 200 },
                    },
                },
                // {
                //     property: 'levelList',
                //     controlConfig: {
                //         style: { width: 200 },
                //     },
                // },
            ],
            fieldRow: {},
            fieldCol: {
                span: 8,
            },
            footer: {
                style: {
                    textAlign: 'right',
                },
            },
            submit: {
                text: '查询',
            },
            reset: true,
        },

        PointProductGoodsBatchBtns: {
            component: 'FlexLayout',
            direction: 'horizontal',
            style: {
                marginBottom: 16,
            },
            align: 'start',
            items: [
                {
                    component: 'UploadButton',
                    buttons: {
                        text: '批量修改上下架状态',
                        type: 'primary',
                    },
                    maxSize: 100 * 1024,
                    successTitle: '导入成功，请稍后查看',
                    failTitle: '导入失败了',
                    accept: '.xls,.xlsx,.csv',
                    action: '/templates/UPDATE_SALES',
                    className: 'upload-button',
                },
                {
                    component: 'ExportButton',
                    text: '下载模板',
                    type: 'default',
                    source: {
                        apiPath: '/templates/UPDATE_SALES',
                    },
                    flex: '0 0 auto',
                },
            ],
        },

        PointProductGoodsDataTable: {
            component: 'DataTable',
            params: {
                type: 'FK_POINTS',
            },
            switchRefresh: true,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: { x: true },
            columns: [
                {
                    property: 'id',
                    modifiable: false,
                },
                {
                    property: 'sku',
                    modifiable: false,
                    width: 220,
                },
                {
                    property: 'spu',
                    modifiable: false,
                    width: 220,
                },
                {
                    property: 'name',
                    modifiable: false,
                    width: 220,
                },
                {
                    property: 'matnr',
                    modifiable: false,
                    width: 130,
                },
                {
                    property: 'ecAvailableStock',
                    modifiable: false,
                    width: 130,
                },
                {
                    property: 'ecStock',
                    modifiable: false,
                },
                {
                    property: 'totalStock',
                    modifiable: false,
                },
                {
                    property: 'saleStatus',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SALES: {
                                text: '上架',
                                status: 'success',
                            },
                            NOT_SALES: {
                                text: '下架',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'pointPrice',
                    modifiable: false,
                },
                {
                    property: 'levelList',
                    width: 150,
                },
                {
                    property: 'maxSaleNum',
                    width: 150,
                    modifiable: false,
                },
                {
                    property: 'putOnSaleTime',
                    width: 150,
                    modifiable: false,
                },
                {
                    property: 'pullOffSaleTime',
                    width: 150,
                    modifiable: false,
                },
            ],
            actionColumn: {
                title: '操作',
                width: 160,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '查看',
                        path: '/product/point-goods/{{row.id}}',
                    },
                    {
                        text: '编辑',
                        type: 'modify',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '保存',
                        type: 'modifyConfirm',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '取消',
                        type: 'modifyCancel',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        type: 'component',
                        component: 'MaxSaleNum',
                    },
                    {
                        type: 'component',
                        component: 'PullOffPutOnSaleOnTime',
                    },
                ],
            },
        },

        PointProductGoodsView: {
            component: 'FlexLayout',
            direction: 'vertical',
            align: 'justify',
            items: [
                {
                    component: 'Card',
                    title: '商品基本属性',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'PointProductGoodsBaseDetail',
                    },
                },
                {
                    component: 'Card',
                    title: '商品库存',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'PointProductGoodsStockDataTable',
                    },
                },
                {
                    component: 'Card',
                    title: '商品可卖数',
                    style: {
                        marginBottom: '16px',
                    },
                    content: {
                        component: 'PointProductGoodsSaleNumberDetail',
                    },
                },
            ],
        },

        PointProductGoodsBaseDetail: {
            component: 'Detail',
            entity: 'productBase',
            loaderType: 'get',
            direction: 'vertical',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 4,
            fields: [
                {
                    property: 'sku',
                    label: 'SKU',
                },
                {
                    property: 'spu',
                    label: 'SPU',
                },
                {
                    property: 'name',
                    label: '名称',
                },
                {
                    property: 'brand',
                    label: '品牌',
                },
                {
                    property: 'showName',
                    label: '展示名称',
                },
                {
                    property: 'pointPrice',
                },
                {
                    property: 'levelNames',
                    label: '会员等级',
                },
            ],
        },

        PointProductGoodsStockDataTable: {
            component: 'DataTable',
            entity: 'productStock',
            loadFirstPage: true,
            columns: [
                {
                    property: 'realStoreName',
                },
                {
                    property: 'storeCode',
                },
                {
                    property: 'sknCount',
                },
            ],
        },

        PointProductGoodsSaleNumberDetail: {
            component: 'Detail',
            entity: 'productSaleNumber',
            loaderType: 'get',
            direction: 'vertical',
            fieldRow: {
                gutter: 32,
            },
            fieldCol: {
                lg: 8,
                md: 12,
                sm: 24,
            },
            labelCol: 4,
            fields: [
                {
                    property: 'canSaleNumber',
                    label: '当前可卖数',
                },
                {
                    property: 'lockStock',
                    label: '待扣减库存',
                },
                {
                    property: 'totalStock',
                    label: '总库存数',
                },
            ],
        },
    },

    routes: [
        {
            path: '/',
            childRoutes: [
                {
                    path: '/product',
                    childRoutes: [
                        {
                            path: '/point-info/:id',
                            component: 'PointProductInfoDetailView',
                            breadcrumbName: '编辑积分商品资料',
                        },
                        {
                            path: '/point-info',
                            component: 'PointProductInfoListView',
                            breadcrumbName: '积分商品资料中心',
                        },

                        {
                            path: '/point-goods/:id',
                            component: 'PointProductGoodsView',
                            breadcrumbName: '查看积分商品经营信息',
                        },
                        {
                            path: '/point-goods',
                            component: 'PointProductGoodsListView',
                            breadcrumbName: '积分商品经营管理',
                        },
                    ],
                },
            ],
        },
    ],
};
